// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2fFG0","log":"ModalInventoryLogs_log__23yLF","date":"ModalInventoryLogs_date__n-fqD","userName":"ModalInventoryLogs_userName__NPNC8"};